module.exports = __webpack_public_path__ + "media/images/menu_izq/hospital-eea8e67a902d3d3c25880d294b6753df.svg";